module.exports = __webpack_public_path__ + "static/media/Desk_room.cfd1d2d4.png";